'use strict';
const angular = require('angular');
import MonthlySellingController from './monthlySelling.controller';
import routes from './monthlySelling.routes';
import cashDeskReportRow from './directives/cashDeskReportRow';
import newClientsReportRow from './directives/newClientsReportRow';
import pulsesReportRow from './directives/pulsesReportRow';

export default angular.module('nomasvelloDashboardApp.monthlySelling', [
    cashDeskReportRow,
    newClientsReportRow,
    pulsesReportRow
])
    .config(routes)
    .controller('MonthlySellingController', MonthlySellingController)
    .name;



// WEBPACK FOOTER //
// ./client/app/manager/monthlySelling/index.ts